module.exports = __webpack_public_path__ + "img/toy_img.a6172dd0.png";